import { NoteContextKey } from '@/shared/api/protocol-ts/model/dto_scribe_catalog_pb';

import { i18n } from '../config';

// A key that a newer server sends is not in the map yet.
export const getNoteContextKeyMessage = (key: NoteContextKey) =>
  i18n.noteContextKeyMessages[key] ??
  i18n.noteContextKeyMessages[NoteContextKey.NoteContextKeyInvalidValue];
